<template>
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.3457 28.0415C21.9204 29.4232 20.3642 29.205 18.8662 28.5506C17.281 27.8815 15.8266 27.8525 14.1541 28.5506C12.0598 29.4523 10.9545 29.1905 9.70377 28.0415C2.60648 20.7261 3.65362 9.58568 11.7108 9.17846C13.6742 9.28026 15.0413 10.2547 16.1902 10.3419C17.9064 9.9929 19.5498 8.98939 21.3823 9.12028C23.5784 9.29481 25.2364 10.1674 26.3271 11.7381C21.7895 14.4578 22.8657 20.4352 27.0252 22.1077C26.1962 24.2893 25.12 26.4563 23.3311 28.0561L23.3457 28.0415ZM16.0448 9.09119C15.8266 5.84797 18.459 3.17194 21.4841 2.91016C21.9059 6.66241 18.0809 9.45478 16.0448 9.09119Z"
      fill="#313131"
    />
  </svg>
</template>
